<template>
<!-- <div class="text-base text-left text-gray-600 dark:text-white/75 font-semibold">
    <n-skeleton v-if="!profile.localization" :width="160" :height="20" :sharp="false" />
    <div v-else class="text-md text-gray-600 dark:text-white/75 font-semibold text-left">
        {{ profile.localization?.comissions || 'Комиссии' }}
    </div>
</div> -->
<section v-if="profile" class="flex flex-wrap mt-2 items-stretch">
    <div class="w-6/12 pr-1">
        <n-card
            size="small"
            :bordered="false"
            class="overflow-hidden shadow bg-white dark:bg-darkCardBg rounded-lg h-full"
            :segmented="{
                content: true,
                footer: 'soft'
            }">
            <template #default>
                <section class="flex">
                    <div class="text-left">
                        <n-skeleton v-if="loading" class="inline-block mt-1" :width="20" :height="26" :sharp="false" />
                        <div
                            v-else
                            class="text-gray-600 dark:text-white/75 text-xl font-semibold">
                            {{ (profile.fullInfo?.commission)?.split(' %')[0] }}
                            <span class="text-base dark:text-white/50 -ml-1">%</span>
                        </div>

                        <n-skeleton v-if="!profile.localization" class="inline-block mt-1" :width="30" :height="14" :sharp="false" />
                        <div v-else class="text-gray-500 dark:text-white/40 mt-1 text-xs">{{ profile.localization?.profile_account_info_commission }}</div>
                    </div>
                </section>
            </template>
            <template #footer>
                <section class="flex items-center text-left text-xs">
                    <div class="text-gray-500 dark:text-white/40 mt-1">
                        {{ profile.localization?.profile_account_info_commission_total_month_label || 'В текущем месяце списано' }}:</div>
                    <div 
                        class="flex items-center text-sm text-lightMain ml-2 whitespace-nowrap mt-1">
                        <span class="font-semibold">{{ profile.fullInfo?.current_month_usd }}</span>
                        <rb-coin class="w-4 ml-2" :coin="getCurrency('usdt')" />
                    </div>
                </section>
            </template>
        </n-card>
    </div>
    <div class="w-6/12 pl-1">
        <n-card
            size="small"
            :bordered="false"
            class="overflow-hidden shadow bg-white dark:bg-darkCardBg rounded-lg h-full"
            :segmented="{
                content: true,
                footer: 'soft'
            }">
            <template #default>
                <section class="flex">
                    <div class="text-left">
                        <n-skeleton v-if="loading" class="inline-block mt-1" :width="20" :height="26" :sharp="false" />
                        <div
                            v-else
                            class="text-gray-600 dark:text-white/75 text-xl font-semibold">
                            {{ (profile.fullInfo?.commission_f)?.split(' %')[0] }}
                            <span class="text-xs dark:text-white/50 -ml-1">%</span>
                        </div>

                        <n-skeleton v-if="!profile.localization" class="inline-block mt-1" :width="30" :height="14" :sharp="false" />
                        <div v-else class="text-gray-500 dark:text-white/40 mt-1 text-xs">{{ profile.localization?.profile_account_info_commission_f }}</div>
                    </div>
                </section>
            </template>
            <template #footer>
                <section class="flex items-center text-left text-xs">
                    <div class="text-gray-500 dark:text-white/40 mt-1">
                        {{ profile.localization?.profile_account_info_commission_total_month_label || 'В текущем месяце списано' }}:</div>
                    <div 
                        class="flex items-center text-xs text-lightMain ml-2 whitespace-nowrap mt-1">
                        <span class="font-semibold">{{ profile.fullInfo?.current_month_usd_f }}</span>
                        <rb-coin class="w-5 ml-2" :coin="getCurrency('usdt')" />
                    </div>
                </section>
            </template>
        </n-card>
    </div>
    <div class="w-6/12 pr-1 mt-2">
        <n-card
            size="small"
            :bordered="false"
            class="overflow-hidden shadow bg-white dark:bg-darkCardBg rounded-lg h-full"
            :segmented="{
                content: true,
                footer: 'soft'
            }">
            <template #default>
                <section class="flex">
                    <div class="text-left">
                        <n-skeleton v-if="loading" class="inline-block mt-1" :width="20" :height="26" :sharp="false" />
                        <div
                            v-else
                            class="text-gray-600 dark:text-white/75 text-xl font-semibold">
                            {{ (profile.fullInfo?.commission_fc)?.split(' %')[0] }}
                            <span class="text-xs dark:text-white/50 -ml-1">%</span>
                        </div>

                        <n-skeleton v-if="!profile.localization" class="inline-block mt-1" :width="30" :height="14" :sharp="false" />
                        <div v-else class="text-gray-500 dark:text-white/40 mt-1 text-xs">{{ profile.localization?.profile_account_info_commission_fc }}</div>
                    </div>
                </section>
            </template>
            <template #footer>
                <section class="flex items-center text-left text-xs">
                    <div class="text-gray-500 dark:text-white/40 mt-1">
                        {{ profile.localization?.profile_account_info_commission_total_month_label || 'В текущем месяце списано' }}:</div>
                    <div 
                        class="flex items-center text-xs text-lightMain ml-2 whitespace-nowrap mt-1">
                        <span class="font-semibold">{{ profile.fullInfo?.current_month_usd_fc }}</span>
                        <rb-coin class="w-5 ml-2" :coin="getCurrency('usdt')" />
                    </div>
                </section>
            </template>
        </n-card>
    </div>
    <div class="w-6/12 pl-1 mt-2">
        <n-card
            size="small"
            :bordered="false"
            class="overflow-hidden shadow bg-white dark:bg-darkCardBg rounded-lg h-full"
            :segmented="{
                content: true,
                footer: 'soft'
            }">
            <template #default>
                <section class="flex">
                    <div class="text-left">
                        <n-skeleton v-if="loading" class="inline-block mt-1" :width="20" :height="26" :sharp="false" />
                        <div
                            v-else
                            class="text-gray-600 dark:text-white/75 text-xl font-semibold">
                            {{ (profile.fullInfo?.commission_m)?.split(' %')[0] }}
                            <span class="text-base dark:text-white/50 -ml-1">%</span>
                        </div>

                        <n-skeleton v-if="!profile.localization" class="inline-block mt-1" :width="30" :height="14" :sharp="false" />
                        <div v-else class="text-gray-500 dark:text-white/40 mt-1 text-xs">{{ profile.localization?.profile_account_info_commission_m }}</div>
                    </div>
                </section>
            </template>
        </n-card>
    </div>
</section>
</template>

<script>
// vue
import { ref, computed, watch } from 'vue';

// store
import { useGl } from '@store/ts/gl';
import { useEnv } from '@store/ts/env';
import { useRefs } from '@store/ts/refs';
import { useProfile } from '@store/profile';

// naive-ui
import {
    NTag,
    NIcon,
    NCard,
    NBadge,
    NButton,
    NSkeleton } from 'naive-ui';

// i18n
import { useI18n } from 'vue-i18n';

// router
import { useRouter } from 'vue-router';

// icons
import {
    Person16Regular }  from '@vicons/fluent';

// components
import RbCoin from '@components/rb-coin';
import TopupBalance from '@components/topup-balance';
import TelegramIcon from '@components/icons/telegram.vue';

export default {
    name: 'account-info-mobile',
    components: {
        NTag,
        NIcon,
        NCard,
        NBadge,
        RbCoin,
        NButton,
        NSkeleton,
        TelegramIcon,
        TopupBalance,
        Person16Regular,
    },
    setup() {
        // store
        const gl = useGl();
        const env = useEnv();
        const refs = useRefs();
        const profile = useProfile();

        // router
        const router = useRouter();

        // i18n
        const { t } = useI18n();

        // vars
        const showModal = ref(false);
        const loading = computed(() => gl.showLoading);
        const currency = computed(() => refs.currencies.find(el => el.id === env.profitSymbol));

        const getCurrency = icon => refs.currencies.find(el => el.id === icon);

        return {
            gl,
            env,
            refs,
            window,
            router,
            loading,
            currency,
            profile,
            showModal,
            t,
            getCurrency,
        };
    },
};
</script>